import { createI18n } from "vue-i18n";
import nlNL from "@wovar/common/i18n/locales/nl.json" with { type: "json" };
import enUS from "@wovar/common/i18n/locales/en.json" with { type: "json" };

export const i18n = createI18n({
  locale: "nl",
  fallbackLocale: "en",
  legacy: false,
  messages: {
    en: enUS,
    nl: nlNL,
  },
});
